export const translations = {
    'en':{
		"Download Sent Record":"Download Sent Record",
		"Download Read Record":"Download Read Record",
		"Download Claimant SMS record":"Download Claimant SMS record",
		"Download Respondent SMS record":"Download Respondent SMS record",
		"Claimant's Email Status":"Claimant's Email Status",
		"Respondent's Email Status":"Respondent's Email Status",
		"mailOptions":"mailOptions",
		"info":"Info",
		"date":"Date",
		"subject":"Subject",
		"Request Signature":"Signing",
		"email":"E-mail",
		"Click to open PDF/Word":"Click to open PDF/Word",
		"SMS":"SMS",
		"Claimant Login Record":'Claimant Login Record',
		"Respondent Login Record":'Respondent Login Record',
		"FPS is not available at the moment":"FPS is not available at the moment",
		"The following clause can be added by the parties to a contract who wish to have any future disputes referred to efficient arbitration in HKAS\’s Online Arbitration Platform:":"The following clause can be added by the parties to a contract who wish to have any future disputes referred to efficient arbitration in HKAS\’s Online Arbitration Platform:",
		"Money Lending dispute":"Money Lending dispute",
		"-Loan Agreement":"- Loan Agreement",
		"-Payment Record":"- Payment Record",
		"-Repayment Record":"- Repayment Record",
		"-Identity Card":"- Identity Card",

		"Estate Agency Dispute":"Estate Agency Dispute",
		"-Property Information Form":"- Property Information Form",
		"-Leasing Information Form":"- Leasing Information Form",
		"-Estate Agency Agreement":"- Estate Agency Agreement",
		"-Payment Record":"- Payment Record",
		"-Identity Card":"- Identity Card",
		"-Provisional Sales and Purchase Agreement":"- Provisional Sales and Purchase Agreement",
		"-Advertisement":"- Advertisement",
		"-Land search":"- Land search",

		"Sales of Goods Dispute":"Sales of Goods Dispute",
		"-Sales of Goods Agreement":"- Sales of Goods Agreement",
		"-Terms and Condition":"- Terms and Condition",
		"-Delivery Record":"- Delivery Record",
		"-Return Record":"- Return Record",
		"-Payment Record":"- Payment Record",
		"-Photo of the Good":"- Photo of the Good",
		"Suggested Documents to be submitted (if applicable)":"Suggested Documents to be submitted (if applicable)",
		"Settlement Chatroom":"Settlement Chatroom",
		"officeAddress":"Room 2205, 22/F,Alliance Building,",
		"officeAddress2":"130-136 Connaught Road Central,",
		"officeAddress3":"Sheung Wan, Hong Kong",
		"Please Enter the Verification Code":"Please Enter the Verification Code",
		"copied":"Copied",
		"copy":"Copy",
		"onlineArbitrationClause":"Any dispute or difference arising out of or in connection with this contract shall be referred to and finally determined by arbitration administrated by the Hong Kong Arbitration Society and in accordance with the HKAS Online Arbitration Rules for the time being in force. The arbitration proceedings shall be conducted in English and the Award shall be written in English.",
		"descriptionText1":"Document",
		"descriptionText2":" ",
		"descriptionPlaceholder":"Enter Description",
		"uploadFileText":"Document ",
		"recommendedDocuments":"Suggested Document List",
		"respondentWillBeNotified":"The Respondent will be notified for the commencement of Arbitration",
		"phoneNumberVerification":"Phone Number Verification",
		"arbitratorProfile":"Learn More",
		"chooseArbitratorSubTitle":"If the parties fail to reach an agreement on who to appoint, the AI system will appoint the most suitable arbitrator to resolve this dispute for the parties.",
		"chooseArbitratorSubTitle2":"Choosing Arbitrator",
		"Arbitration Computer":"仲裁計算機",
		"Address":"Address",
		"contactUs":"Contact Us",
		"tele":"Tel",
		"fax":"Fax",
		"generalInquiry":"Enquiries",
		"officeHour":"Office Hours",
		"monToFri":"Mon to Fri: ",
		"morningTime":"9:30am - 1pm &",
		"afternoonTime":" 2pm to 6pm",
		"holidays":"Sat, Sun and Public Holidays: Closed",
		"socialMedia":"Social Media",
		"aboutUs":"About Us",
		"aboutHkas":"HKAS",
		"mission":"Our Mission",
		"bylaws":"Constitution",
		"hkasInfo":"Announcement",
		"radioShow":"Radio Program",
		"hkasNews":"Society News",
		"mainPageTitle":"Justice at your fingertips",
		"mainPageTitle2":"Dispensing with Personal Attendance",
		"mainPageText":"Hong Kong Arbitration Society introduces the Online Arbitration Platform, which adopts a combination of online technologies and artificial intelligence (AI) to resolve disputes. It is a form of arbitration which is more efficient, cost-effective and affordable than litigation and the traditional mode of arbitration. The parties in dispute will not need to attend the arbitration hearing in person. Instead, they can provide submission and evidence at any time, regardless of geographical distance. The arbitrator will be able to deliver the final award within one month. The award is enforceable in the same manner as a court judgment, and can be enforced in different territories.",
		"icon6Text":"Trade Dispute",
		"icon4Text":"Lending Dispute",
		"icon9Text":"Insurance Dispute",
		"icon5Text":"Sales Dispute",
		"icon7Text":"Estate Agency Dispute",
		"icon10Text":"Service Dispute",
		"mainB1":"Arbitration Procedure",
		"mainB2":"Arbitration Fee Calculator",
		"mainMidTitle":"Commencement of Arbitration",
		"mainMidTitle2":"4 ways to start",
		"mainB3":"1. Add the Online Arbitration Clause to the Contract",
		"mainB4":"2. Sign an Online Arbitration Agreement",
		"mainB5":"3. If none of above is applicable, you may still draft the Arbitration Notice by using the AI technology.",
		"mainB6":"4. By Document Uploads Only",
		"docUpload_dropText":"Drag & drop files here, or click to browse",
		"docUpload_dropSubText":"You can drop multiple files at once",
		"docUpload_title":"Document Upload",
		"docUpload_subtitle":"Upload your documents below. Each document requires a description before uploading.",
		"docUpload_requiredNote":"All fields are required.",
		"docUpload_document":"Document",
		"docUpload_chooseFile":"Choose File",
		"docUpload_changeFile":"Change File",
		"docUpload_descLabel":"Description",
		"docUpload_descPlaceholder":"Briefly describe the content of this document...",
		"docUpload_addDoc":"Add Another Document",
		"docUpload_uploadBtn":"Upload All Documents",
		"docUpload_uploading":"Uploading...",
		"docUpload_remove":"Remove",
		"docUpload_back":"Back",
		"docUpload_backHome":"Back to Home",
		"docUpload_errorNoFile":"Please select a file.",
		"docUpload_errorInvalidType":"Only PDF, DOCX, and image files are allowed.",
		"docUpload_errorNoDesc":"Please enter a description for this document.",
		"docUpload_errorUploadFailed":"Upload failed. Please try again.",
		"docUpload_successTitle":"Documents Uploaded Successfully!",
		"docUpload_successMsg":"Your documents have been submitted. Our team will review them shortly.",
		"timeline1":"1. Arbitration Agreement Firstly, parties must indicate that theywant to resolve the dispute through theonline arbitration platform to settledisputes. They may either add the online arbitration clause to theircontract, or they can sign online in theplatform.",
		"timeline2":"2. Aribitration AI Chatbot If a party already agreed to onlinearbitration, the party who want to claimmay start the proceeding by starting achatbot conversation to input the  d information of the claim. The platformwill draft the Arbitration Notice using Aitechnology.",
		"timeline3":"3. Verification You will receive a SMS to verify your identity.",
		"timeline4":"4. Appointment of Arbitrator The (Claimant) party could propose their own choice of arbitrator to the other party (Respondent). The Respondent may counter-propose their own arbitrator. If the parties fail to reach an agreement on who to appoint, the AI platform will appoint a suitable arbitrator for the parties.",
		"timeline5":"5. Arbitration Notice The Claimant should check that all necessary details have been correctly included in the Arbitration Notice. If there is any incorrect/ incomplete details, you may re-start the chatbot conversasion.",
		"timeline6":"6. 網上簽署如果資料正確，便可以在網上簽署。",
		"timeline7":"7. 仲裁費用當事人需要預繳仲裁費用，而勝方最後可獲全數退款。",
		"timeline8":"8. 上傳文件當事人可以將相關及支持自己理據的文件上傳到平台的雲端。",
		"timeline9":"9. 通知答辯人答辯人將會獲得通知，並作出回應。",
		"mainLastB":"Start",
		"lastl1":"Hong Kong Arbitration Society believes ",
		"lastl1r":" disputes can be resolved differently ",
		"lastl2":" and aims to promote the resolution of ",
		"lastl2r":" ",
		"lastl3":"disputes through a form of arbitration ",
		"lastl32":" which is ",
		"lastl3r":" more efficient, cost-effective ",
		"lastl3br":" and affordable ",
		"lastB":"Learn More",
		"arbitrator":"Arbitrator",

		"Arbitration Computer":"Arbitration Fee Calculator",
		"Address":"Address",
		"Please press ‘Refresh’ button of the browser in order to view the contents.":"Please press ‘Refresh’ button of the browser in order to view the contents.",
		"Please read the contents and choose to amend or confirm them.":"Please read the contents and choose to amend or confirm them.",
		"The respondent choosen arbitrator is":"The respondent choosen arbitrator is",
		"Save the choosen Arbitrator":"Save the choosen Arbitrator",
		"The claimant choosen arbitrator is":"The claimant choosen arbitrator is",
		"List of selected arbitrators":"List of Proposed Arbitrator",
		'Date of Beginning of Proceedings':'Date of Beginning of Proceedings',
		'Deadline to file the Response':'Deadline to file the Response',
		'Deadline for Preliminary Enquiry':'Deadline for Preliminary Enquiry',
		'Deadline to file additional information and documents':'Deadline to file additional information and documents',
		'Deadline for submission, interrogatory, and Enquiry':'Deadline for submission, interrogatory, and Enquiry',
		'Deadline for the delivery of Arbitral Award':'Deadline for the delivery of Arbitral Award',
		'Hong Kong Arbitration Society appointed':'Hong Kong Arbitration Society appointed',
		'as the Arbitrator of the present arbitration proceedings on':'as the Arbitrator of the present arbitration proceedings on',
		'Case Date':'Case Date',
		'Request Claimant Signature':'Request Claimant Signature',
		'Request Respondent Signature':'Request Respondent Signature',
		'Skip Payment':'Skip payment for Claimant',
		'Enquiry by arbitrator is completed':'No Preliminary Enquiry',
		'The signature cannot be identified, please sign again.':'The signature cannot be identified, please sign again.',
		'Paid':'Paid',
		'Change No. Of Days':'Change No. Of Days',
		'Username or password is incorrect':'Username or password is incorrect',
		'Two Factor Auth code sent via':'Two Factor Auth code sent via',
		'2FA Code is incorrect':'2FA Code is incorrect',
		'Appointment of Arbitrator':'Appointment of Arbitrator',
		'End Date:':'End Date:',
		'3DaysDescription':'The Claimant and the Respondent have to agree on the appointment of an Arbitrator from the List of Arbitrators within',
		'3DaysDescription2':'days. The Claimant has to propose an Arbitrator first and the Respondent then has to decide whether to accept or reject such proposal. If the Respondent rejects such proposal, the Respondent may choose another Arbitrator. If the Claimant and the Respondent agree on the appointment of an Arbitrator, the potential Arbitrator will decide whether to accept or reject the appointment to the arbitration proceedings. If the potential Arbitrator rejects it, the Claimant has to propose another Arbitrator.  If the Claimant and the Respondent fail to agree on the appointment of an Arbitrator within',
		'3DaysDescription3':'days, the Hong Kong Arbitration Society shall have the sole discretion and Artificial Intelligence will choose the most suitable Arbitrator for the arbitration proceedings.',
		'The Respondent proposes ':'The Respondent proposes ',
		'as the Arbitrator; do you accept or not?':' as the Arbitrator; do you accept or not?',
		// 'The Claimant proposes':'The Claimant proposes ',
		'Upload Full PDF':'Upload Full PDF',
		' as the Arbitrator; do you accept or not?':' as the Arbitrator; do you accept or not?',
		'Print':'Print',
		'Amend':'Amend',
		'Re-enter':'Re-enter',
		'I certify that information contained in the Response is true and correct and consent to submit the difference to arbitration.':'I certify that information contained in the Response is true and correct and consent to submit the difference to arbitration.',
		'I certify that information contained in the Arbitration Notice is true and correct.':'I certify that information contained in the Arbitration Notice is true and correct.',
		'Hearing not scheduled or meeting time not yet arrive':'Hearing not scheduled or meeting time not yet arrive',
		'Schedule Meeting with Video':'Schedule Meeting with Video',
		'Schedule Meeting Audio Only':'Schedule Meeting Audio Only',
		'Deliver Award':'Deliver Award',
		'The arbitration fees will be paid to the arbitration service provider approved by Hong Kong Arbitration Society. ':'The arbitration fees will be paid to the arbitration service provider approved by Hong Kong Arbitration Society.',
		'Identity Number':'Identity Number',
		'Release':'Release',
		'Done':'Done',
		'Dear Arbitrator, Please sign the award. If satisfied with signature, please click done. Once signed it will be released. you may resubmit the signature multiple times here. After release, you may download DOCX version and re-upload.':'Dear Arbitrator, Please sign the award. If satisfied with signature, please click done. Once signed it will be released. you may resubmit the signature multiple times here. After release, you may download DOCX version and re-upload.',
		'Reject':'Reject',
		'Accept':'Accept',
		'Does the arbitrator accept or reject this case?':'Do you confirm that there is no conflict of interest in relation to your appointment as the Arbitrator to this dispute and agree to be appointed as the Arbitrator?',
		'Does the admin accept or reject this case or require more information?':'Does the admin accept or reject this case or require more information?',
		'The arbitrator has rejected the case.':'The arbitrator has rejected the case.',
		'The Arbitrator has not delivered the Award yet.':'No Arbitral Award is delivered yet',
		'Send':'Send',
		'Prev. Page':'Prev. Page',
		'Next Page':'Next Page',
		'Download PDF':'Download PDF',
		'Download Word': 'Download Word',
		'PDF':'PDF',
		'Upload':'Upload',
		'Download': 'Download',
		'About Online Arbitration': 'About Online Arbitration',
		'description1':'Hong Kong Arbitration Society launched the Online Arbitration Platform in 2019. It aims to handle the whole arbitration proceeding online so that the parties do not have to meet in person and it can resolve dispute at any time regardless of geographical distance.',
		'description2':'Arbitration proceedings are similar to court proceedings in a number of ways, but are different to mediation of which the parties will try to settle the case voluntarily, in that an arbitral tribunal can decide the case which is enforceable in the same manner as a court judgment. The decision by the arbitrator is binding and enforceable in Hong Kong, mainland China and over 160 countries around the world and are enforceable in the same manner as a court judgment with the leave of the court pursuant to the Arbitration Ordinance Cap. 609. It will be particular useful to resolve cross border dispute in the Guangdong-Hong Kong-Macau Greater Bay Area and most countries along the Belt and Road Initiatives.',
		'description3':'The arbitration fee is charged based on amount in dispute, it is fixed and is more affordable and cost-effective than litigation. The winning party can receive a full refund after winning the case.',
		'description4':'If the parties like to use the online arbitration platform, they may either add the online arbitration clause to their contract to indicate that they want to resolve the dispute through the online arbitration platform or they can sign online in the platform agreeing to use the online arbitration platform.',
		'description5':'In relation to the online arbitration proceedings, firstly, if a party already agreed to online arbitration, the party who want to claim may start the proceeding by starting a chatbot conversation to input the information of the claim. The platform will draft the Arbitration Notice using Ai technology, the claimant can then proceed to the verification, payment, proofread of the arbitration notice and making of electronic signature. The arbitration notice will send to the respondent online subsequently and the respondent has to login the platform and go through similar procedure to defense the case. The parties can upload the relevant documents to the cloud of the platform and can appoint an arbitrator.',
		'description6':'There is a chatroom for parties only without the arbitrator so that the parties can discuss settlement and another chatroom with both parties and arbitrator so that the parties and arbitrator can request information and documents in this chatroom in the early stage and the parties can make interrogatories and submission and the arbitrator can make enquiries in the later stage. The arbitrator will then deliver the award online and the whole process will only take one month.',
		'description7':' ',
		'description8':' ',
		'description9':' ',
		'description10':' ',
		'description11':' ',
		'description12':' ',
		'Back':'Back',
        'Arbitrator’s List': 'List of Arbitrators',
        'Arbitration Rules': 'Arbitration Rules',
        'Arbitration Procedure': 'Arbitration Procedure',
        'Arbitration Agreement': 'Arbitration Agreement',
        'Online Arbitration Clauses': 'Online Arbitration Clause',
		'Arbitration Clause':'Arbitration Clause',
        'Username': 'Username',
		'2FA Code': '2FA Code',
        'Password': 'Password',
        'Login': 'Login',
        'Chatbot': 'Chatbot',
        'Userinfo': 'User info',
        'Verification': 'Verification',
        'Choose Arbitrator': 'Appointing',
        'Choose Arbitrator2': 'Arbitrator',
        'Read PDF': 'Read PDF',
        'Signature': 'Signature',
        'Payment': 'Payment',
        'Upload Documents': 'Upload',
        'Upload Documents2': 'Documents',
        'Skip': 'Skip',
        'Next': 'Next',
        'Phone Number Verification': 'Phone Number Verification',
        'Email Verification': 'Email Verification',
        "Please press 'RECEIVE CODE' to get a verification code": "Please press 'RECEIVE CODE' to get a verification code",
		"Thank you. Signature is saved.":"Thank you. Signature is saved.",
        'Receive Code': 'Receive Code',
		'Please enter a valid email address for future communication.':'Please enter a valid email address for future communication.',
		'Please enter valid email address.':'Please enter valid email address.',
		'Email saved.':'Email saved.',
        'A text message with your code has been send to:': 'A text message with your code has been send to:',
        'Verify': 'Verify',
        'Please provide your signature below': 'Please read the contents of the Arbitration Notice carefully before signing',
        'Please provide your signature belowAward': 'Please read the contents of the Award carefully before signing',
        'Please provide your signature below.': 'Please read the contents of the Response carefully before signing',
        'Clear': 'Clear',
        'Submit': 'Submit',
		'Confirm': 'Confirm',
        'Confirm Signature': 'Confirm Signature',
        'Please select payment method': 'Please select a payment method',
        'Order details': 'Order details',
		'Dispute amount' : 'Arbitration amount',
		'Choose Date/Time':'Choose Date/Time:  ',
        'Arbitration Fee': 'Arbitration Fee',
        'Final Total': 'Final Fee',
        'Final Total for Hearing': 'Final Total for Hearing',
        'Reset': 'Reset',
        'Upload': 'Upload',
        'Finish': 'Finish',
        'Add File': 'Add File',
		'Scheduled Award Delivery Date':'Scheduled Award Delivery Date',
		'Schedule':'Schedule',
		'Cancel Schedule':'Cancel Schedule',
		'The scheduled award delivery is on':'The scheduled award delivery is on',
        'Case Information': 'Case Information',
        'Arbitration Notice': 'Arbitration Notice',
        'Response': 'Response',
        'Documents': 'Documents',
        'Settlement': 'Settlement',
        'Reopen Case': 'Reopen Case',
        'confirmSettleCase': 'Are you sure you want to settle/close this case? No further emails, SMS, or processing will occur.',
        'confirmReopenCase': 'Are you sure you want to reopen this case?',
        'caseIsSettled': 'This case has been settled/closed.',
        'Enquiries & Submission': 'Enquiries & Submission',
        'Hearing': 'Hearing',
        'Award': 'Award',
		'Yes': 'Yes',
		'No': 'No',
		'No2':'No',
		'Browse': 'Browse',
		'Select Options': 'Select Options',
		'Case Number': 'Case Number',
		'Arbitrator': 'Arbitrator ',
		'rejected the case.': ' rejected the appointment as Arbitrator to the arbitration proceedings. Please choose another arbitrator.',
		'accepted the case.': ' accepted the appointment as Arbitrator to the arbitration proceedings.',
		'Waiting for arbitrator to accept or reject the case.': 'Waiting for the Arbitrator to accept or reject the Appointment.',
		'Claimant\'s Information': 'Claimant\'s Information',
		'Name': 'Name',
		'Address': 'Address',
		'E-mail': 'E-mail',
		'Telephone No': 'Contact',
		'Payment Status': 'Payment Status',
		'Status': 'Status',
		'Claimant': 'Claimant',
		'Respondent': 'Respondent',
		'Deadline to next step': 'Deadline to next step',
		'Claimant\'s Documents': 'Claimant\'s Documents',
		'Add No. of Days': 'Add No. of Days',
		'Timer Panel': 'Timer Panel',
		'Document Name': 'Document Name',
		'Uploaded Date': 'Date Uploaded',
		'File': 'File',
		'Respondent\'s Documents': 'Respondent\'s Documents',
		'HKAS\'s Documents': 'HKAS\'s Documents',
		'Upload New Files': 'Upload New Files',
		'reset': 'reset',
		'browse': 'browse',
		'The Parties can negotiate for settlement in this page ': 'Parties could negotiate for settlement solution in this',
		'and the Arbitrator cannot read the contents': 'chatroom, the Arbitrator could not read the contents',
		'Claimant Offer': 'Claimant\'s Offer',
		'Respondent Offer': 'Respondent\'s Offer',
		'Make a new offer': 'New Offer',
		'Accept': 'Accept',
		'Refuse': 'Refuse',
		'Offer': 'Offer',
		'The Parties and the Arbitrator can make Preliminary Enquiries': 'HKAS, Arbitrator and Parties can make Application, Order and Direction and ',
		'Submission, Interrogatories and Enquiries in this chatroom': 'conduct Preliminary Enquiry, Interrogatory, Submission and Enquiry in this Chatroom.',
		'Case File': 'Case File',
		'New Case': 'New Case',
		'Processing Cases': 'Processing Cases',
		'Closed Cases': 'Closed Cases',
		'Rejected Cases': 'Rejected Cases',
		'All Cases': 'All Cases',
		'Online Arbitration': 'Online Arbitration',
		'Setting': 'Setting',
		'Personal Information': 'Personal Information',
		'Change Password': 'Change Password',
		'Logout': 'Logout',
		'Forgot Password': 'Forgot Password',
		'Please enter the username of your account. An email will be sent to your email address for recovery.':'Please enter the username of your account. An email will be sent to your email address for recovery.',
		'About Online Arbitration': 'About Online Arbitration',
		'Arbitrator’s List': 'Arbitrator’s List',
		'Arbitration Rules': 'Arbitration Rules',
		'arbitration_agreement1': 'We, the undersigned, agree to refer to arbitration administered by the Hong Kong Arbitration Society under the HKAS Online Arbitration Rules any dispute, controversy, difference or claim (including any dispute regarding non-contractual obligations) arising out of or relating to:',
		'arbitration_agreement2': 'Brief description of contract under which disputes, controversies, differences or claims have arisen or may arise.',
		'arbitration_agreement3': 'The arbitration proceedings shall be conducted in English and the Award shall be written in English.',
		'For an amount in dispute (HK$)': 'For an amount in dispute (HK$)',
		'Online Arbitration Fees': 'Online Arbitration Fees',
		'Arbitration Fees (HK$)': 'Arbitration Fees (HK$)',
		'Enter dispute amount': 'Enter dispute amount',
		'Arbitrator fee': 'Arbitrator fee',
		'Any dispute or difference arising out of or in connection with this contract shall be referred to and finally determined by arbitration administrated by the Hong Kong Arbitration Society and in accordance with the HKAS Online Arbitration Rules for the time being in force. The arbitration proceedings shall be conducted in English and the Award shall be written in English': 'Any dispute or difference arising out of or in connection with this contract shall be referred to and finally determined by arbitration administrated by the Hong Kong Arbitration Society and in accordance with the HKAS Online Arbitration Rules for the time being in force. The arbitration proceedings shall be conducted in English and the Award shall be written in English',
		'Signed': 'Signed',
		'1st Party': '1st Party',
		'2nd Party': '2nd Party',
		'Date': 'Date',
		'Respondent\'s Information': 'Respondent\'s Information',
		'Arbitration Clauses/Agreement': 'Arbitration Clauses/Agreement',
		'Document Number': 'Document Number',
		'claimantArbitrator':'Arbitrator proposed by Claimant:',
		'respondentArbitrator':'Arbitrator proposed by Respondent:',
		'The parties can fill in the details and sign this Agreement in order to refer the dispute to HKAS Online Arbitration Platform.':'The parties can fill in the details and sign this Agreement in order to refer the dispute to HKAS Online Arbitration Platform.',
		'Contact of 2nd Party':'Phone No. of 2nd Party : ',
		'Contact of 1st Party':'Phone No. of 1st Party : ',
		'Name of 1st Party':'Name of 1st Party : ',
		'E-mail of 1st Party':'E-mail of 1st Party : ',
		'Name of 2nd Party':'Name of 2nd Party : ',
		'E-mail of 2nd Party':'E-mail of 2nd Party : ',
		'Email of 2nd Party':'Email of 2nd Party : ',
		'Signature of 1st Party:':'Signature of 1st Party : ',
		'Signature of 2nd Party:':'Signature of 2nd Party : ',
		'1st Party email is required or incorrect':'1st Party email is required or incorrect',
		'2nd Party email is required or incorrect':'2nd Party email is required or incorrect',
		'1st Party name is required':'1st Party name is required',
		'2nd Party name is required':'2nd Party name is required',
		'1st Party signature is required':'1st Party signature is required',
		'2nd Party signature is required':'2nd Party signature is required',
		'The agreement has been successfully saved. Thank you.':'The agreement has been successfully saved. Thank you.',
		'Arbitration Fee Calculator':'Arbitration Fee Calculator',
		'Enter Dispute Amount':'Enter Dispute Amount',
		'Jurisdiction':'Jurisdiction',
		'Occupation':'Occupation',
		'No offer yet':'No offer at this moment',
		'An error occurred, please try again / or offer was made by the other party.':'An error occurred, please try again / or offer was made by the other party.',
		'Please input the description before uploading file.':'Please input the description before uploading file.',
		'The respondent has not yet responded.':'The Respondent has not responded.',
		'Yes':'Yes',
		'Send Again':'Send Again',
		'No':'No',
		'Accept':'Accept',
		'Reject':'Reject',
		'Upload Full PDF':'Upload Full PDF',
		'The Claimant proposes':'The Claimant proposes',
		'The Respondent proposes':'The Respondent proposes',
		'Do you still wish to continue with your current choice,':'Do you still wish to continue with your current choice,',
		'to be the Arbitrator, will the Respondent accept or reject this proposal?':'to be the Arbitrator, will the Respondent accept or reject this proposal?',
		'to be the Arbitrator, will the Claimant accept or reject this proposal?':'to be the Arbitrator, will the Claimant accept or reject this proposal?',
		'AgreementNo':'Agreement Number',
		'The following clause can be added by the parties to a contract who wish to have any future disputes referred to efficient arbitration in HKAS’s Online Arbitration Platform:':'The following clause can be added by the parties to a contract who wish to have any future disputes referred to efficient arbitration in HKAS\'s Online Arbitration Platform:',
		'(Parties to an existing dispute in which neither an arbitration clause nor a previous agreement with respect to arbitration exists, may sign the following agreement to refer such dispute to arbitration through our Online Arbitration Platform)':'(Parties to an existing dispute in which neither an arbitration clause was added nor a arbitration agreement was entered, may sign the following agreement to refer such dispute to resolve by arbitration through our Online Arbitration Platform)',
		'WeChat Pay / AliPay':'AliPay / WeChat Pay',
		'PayPal / CreditCard':'PayPal / CreditCard',
		'fps':'FPS',
		'Full Docx': 'Full Docx',
		'Please choose arbitrator.':'Please choose arbitrator.',
		'Please upload word (.docx) file and it will be converted to PDF automatically.':'Please upload word (.docx) file and it will be converted to PDF automatically. After Press UPLOAD, Please wait patiently for page to refresh.',
		'Please choose your arbitrator.':'Please choose your arbitrator.',
		'uploading':'loading...',
		'SubmitAndSetAsDefault':'Set as Default',
		'useDefaultSignature':'Use default',
		'An email has been sent for signing.':'An email has been sent for signing.',
		"There is no case in this account.":"There is no case in this account.",
    },
    'cn': {	
		"Download Sent Record":"下載電子訊息記錄",
		"Download Read Record":"下載已閱記錄",
		"Download Claimant SMS record":"下載申請人電子訊息記錄",
		"Download Respondent SMS record":"下載答辯人電子訊息記錄",
		"Claimant's Email Status":"申請人電子郵件狀態",
		"Respondent's Email Status":"答辯人電子郵件狀態",
		"mailOptions":"mailOptions",
		"info":"Info",
		"date":"Date",
		"subject":"主題",
		"Request Signature":"簽署",
		"There is no case in this account.":"這個帳戶沒有案件。",
		"An email has been sent for signing.":"電郵已送出以進行簽署。",
		"email":"電子郵件",
		"Click to open PDF/Word":"Click to open PDF/Word",
			"SMS":"SMS",
			"Claimant Login Record":'申請人登入記錄',
			"Respondent Login Record":'答辯人登入記錄',
			"FPS is not available at the moment":"FPS is not available at the moment",
			'Arbitration Clause':'加入網上仲裁條款',
			"The following clause can be added by the parties to a contract who wish to have any future disputes referred to efficient arbitration in HKAS\’s Online Arbitration Platform:":"希望在香港仲裁公會的網上仲裁平台進行高效仲裁以解決未來爭議的當事人,可在合同中加入仲裁條款如下:",
			"Money Lending dispute":"債務糾紛",
			"-Loan Agreement":"- 貸款合約",
			"-Payment Record":"- 付款記錄",
			"-Repayment Record":"- 還款記錄",
			"-Identity Card":"- 身份證明",

			"Estate Agency Dispute":"地產代理糾紛",
			"-Property Information Form":"- 物業資料表",
			"-Leasing Information Form":"- 租賃資料表",
			"-Estate Agency Agreement":"- 地產代理協議",
			"-Payment Record":"- 付款記錄",
			"-Identity Card":"- 身份證明",
			"-Provisional Sales and Purchase Agreement":"- 臨時買賣協議",
			"-Advertisement":"- 廣告",
			"-Land search":"- 土地搜尋",

			"Sales of Goods Dispute":"貨品銷售糾紛",
			"-Sales of Goods Agreement":"- 貨品銷售協議",
			"-Terms and Condition":"- 附帶條約",
			"-Delivery Record":"- 送貨記錄",
			"-Return Record":"- 退貨記錄",
			"-Payment Record":"- 付款記錄",
			"-Photo of the Good":"- 貨品相片",
		
		"Suggested Documents to be submitted (if applicable)":"建議提交的文件(如適用)",
		"Settlement Chatroom":"和解聊天室",
		"officeAddress":"香港干諾道中130-136號",
		"officeAddress2":"誠信大廈",
		"officeAddress3":"22字樓2205室",
		"Please Enter the Verification Code":"請輸入驗證碼",
		"copied":"已復制",
		"copy":"複製",
		"onlineArbitrationClause":"凡因本合同所引起的或與之相關的任何爭議或意見分歧，均應提交香港仲裁公會進行機構仲裁，並按其現行有效的香港仲裁公會網上仲裁規則最終解決。仲裁程序應以中文進行，裁決應以中文草擬。",
		"descriptionText1":"輸入文件",
		"descriptionText2":"説明",
		"descriptionPlaceholder":"輸入説明",
		"uploadFileText":"上傳文件",
		"recommendedDocuments":"建議提交的文件（如適用)",
		"respondentWillBeNotified":"答辯人將會獲得通知本仲裁已經展開",
		"phoneNumberVerification":"電話號碼驗證",
		"arbitratorProfile":"了解仲裁員資料",
		"chooseArbitratorSubTitle":"如雙方所選擇之仲裁員不一致，人工智能系統將為",
		"chooseArbitratorSubTitle2":"雙方揀選出合適之仲裁員。",
		"Arbitration Computer":"仲裁計算機",
		"Address":"地址",
		"contactUs":"聯絡我們",
		"tele":"電話",
		"fax":"傳真",
		"generalInquiry":"一般查詢",
		"officeHour":"辦公時間",
		"monToFri":"星期一至五",
		"morningTime":"上午九時三十分至下午一時正",
		"afternoonTime":"下午二時正至六時正",
		"holidays":"星期六、日及公眾假期: 休息",
		"socialMedia":"社交媒體",
		"aboutUs":"關於我們",
		"aboutHkas":"關於香港仲裁公會",
		"mission":"公會使命",
		"bylaws":"章程",
		"hkasInfo":"公會資訊",
		"radioShow":"電台節目",
		"hkasNews":"公會消息",
		"mainPageTitle":"毋須親身會面，公義就在指尖",
		"mainPageTitle2":" ",
		"mainPageText":"香港仲裁公會推出網上仲裁平台，結合網上技術與人工智能，採用較訴訟和傳統仲裁更高效的模式，以大眾能負擔的費用，進行解決爭議的程序。雙方毋須親身出席聆訊，可以不受地域或時間限制，提出陳述及証據，讓仲裁員於大約一個月的時間內作出最終裁決。仲裁的裁決如法庭判決一樣具法律約束力，並可跨境執行。",
		"icon6Text":"貿易",
		"icon4Text":"借貸",
		"icon9Text":"保險糾紛",
		"icon5Text":"貨品銷售",
		"icon7Text":"地產代理",
		"icon10Text":"服務糾紛",
		"mainB1":"仲裁程序",
		"mainB2":"網上仲裁費用計算機",
		"mainMidTitle":"展開網上仲裁",
		"mainMidTitle2":"四種方案展開仲裁程序",
		"mainB3":"1. 加入網上仲裁條款",
		"mainB4":"2. 網上簽署協議",
		"mainB5":"3. 如以上方案不適用，閣下亦可先以人工智能系統草擬所需文件",
		"mainB6":"4. 只需上傳文件",
		"docUpload_dropText":"拖放文件到此，或點擊瀏覽",
		"docUpload_dropSubText":"支持同時拖放多個文件",
		"docUpload_title":"上傳文件",
		"docUpload_subtitle":"請在下方上傳您的文件，每份文件均需填寫說明。",
		"docUpload_requiredNote":"所有欄位均為必填。",
		"docUpload_document":"文件",
		"docUpload_chooseFile":"選擇文件",
		"docUpload_changeFile":"更換文件",
		"docUpload_descLabel":"說明",
		"docUpload_descPlaceholder":"請簡要描述此文件的內容…",
		"docUpload_addDoc":"新增文件",
		"docUpload_uploadBtn":"上傳所有文件",
		"docUpload_uploading":"正在上傳…",
		"docUpload_remove":"移除",
		"docUpload_back":"返回",
		"docUpload_backHome":"返回主頁",
		"docUpload_errorNoFile":"請選擇文件。",
		"docUpload_errorInvalidType":"只接受 PDF、DOCX 及圖片格式。",
		"docUpload_errorNoDesc":"請為此文件填寫說明。",
		"docUpload_errorUploadFailed":"上傳失敗，請重試。",
		"docUpload_successTitle":"文件上傳成功！",
		"docUpload_successMsg":"您的文件已提交，我們的團隊將盡快審閱。",
		"timeline1":"1. 仲裁協議雙方需先同意於本網上仲裁平台通過仲裁解決爭議。雙方可以在合同事先加上仲裁條款，或者在網上仲裁平台簽署仲裁協議並獲得協議編號，其中一方亦可以先展開仲裁，再由另一方確認是否同意以仲裁解決爭議。",
		"timeline2":"2. 仲裁智能聊天機械人仲裁啟動時，申請人將開始與聊天機械人對話，以提交資料及說明申索性質。之後，平台將使用人工智能技術草擬仲裁通知書。",
		"timeline3":"3. 身份認證平台將會以SMS短訊形式為當事人認證身份。",
		"timeline4":"4. 委任仲裁員當事人可以就仲裁員作出建議，委任雙方同意的仲裁員。如果雙方未能同意，平台將會以人工智能選出最適合解決此爭議的仲裁員。",
		"timeline5":"5. 校對仲裁通知書申請人需要校對仲裁通知書的內容，如果資料錯誤可以在聊天機械人重新輸入。",
		"timeline6":"6. 網上簽署如果資料正確，便可以在網上簽署。",
		"timeline7":"7. 仲裁費用當事人需要預繳仲裁費用，而勝方最後可獲全數退款。",
		"timeline8":"8. 上傳文件當事人可以將相關及支持自己理據的文件上傳到平台的雲端。",
		"timeline9":"9. 通知答辯人答辯人將會獲得通知，並作出回應。",
		"mainLastB":"開始網上仲裁",
		"lastl1":"香港仲裁公會相信可以透過嶄新方式",
		"lastl1r":"解決爭議",
		"lastl2":"並致力推廣以較訴訟和傳統仲裁",
		"lastl2r":"更有效率",
		"lastl3":"和",
		"lastl3r":"大眾能負擔",
		"lastl3b":"的仲裁方式去解決爭議",
		"lastB":"了解更多",
		"arbitrator":"仲裁員",
		"":"",
		"":"",
		"":"",
		"":"",
		"":"",
		"":"",
		"":"",
		"":"",
		"":"",
		"":"",
		"":"",
		"":"",
		"Please press Refresh button of the browser in order to view the contents.":"請按瀏覽器的「重新整理」”Refresh” 鍵以閲讀內容。",
		"Please read the contents and choose to amend or confirm them.":"請閱讀內容並選擇修改或確認。",
		"The respondent choosen arbitrator is":"The respondent choosen arbitrator is",
		"Save the choosen Arbitrator":"Save the choosen Arbitrator",
		"The claimant choosen arbitrator is":"The claimant choosen arbitrator is",
		"List of selected arbitrators":"List of Proposed Arbitrator",
		'Date of Beginning of Proceedings':'程序開始日期',
		'Deadline to file the Response':'提交回應書的期限',
		'Deadline for Preliminary Enquiry':'初步審查的期限',
		'Deadline to file additional information and documents':'提供進一步資料和文件的期限',
		'Deadline for submission, interrogatory, and Enquiry':'陳詞、質詢和查問的期限',
		'Deadline for the delivery of Arbitral Award':'作出仲裁裁決的期限',

		'Hong Kong Arbitration Society appointed':'香港仲裁公會已於',
		'as the Arbitrator of the present arbitration proceedings on':'為本仲裁案件的仲裁員。',
		'Case Date':'案件日期',
		'Request Claimant Signature':'Request Claimant Signature',
		'Request Respondent Signature':'Request Respondent Signature',
		'Skip Payment':'Skip payment for Claimant',
		'Enquiry by arbitrator is completed':'沒有初步審查',
		'The signature cannot be identified, please sign again.':'簽名未能被認明，請再次簽署。',
		'Paid':'已付款',
		'Change No. Of Days':'更改天數',
		'Username or password is incorrect':'用戶名或密碼不正確',
		'Two Factor Auth code sent via':'雙重認證代碼透過以下方式發送',
		'2FA Code is incorrect':'2FA 代碼不正確',
		'Appointment of Arbitrator':'委任仲裁員',
		'End Date:':'截止日期:',
		'3DaysDescription':'申請人與答辯人須在3天內從仲裁員名單中就委任一名仲裁員達成協議。申請人首先建議一名仲裁員，然後答辯人必須決定是接受或是拒絕該建議。如果答辯人拒絕該建議，答辯人可以選擇另一位仲裁員。如果申請人與答辯人就仲裁員的委任達成協議，則該準仲裁員將決定是否接受或拒絕被委任處理該仲裁程序。如果準仲裁員拒絕，則申請人須再建議另一位仲裁員。如果申請人與答辯人在三天內未能就委任仲裁員達成協議，則香港仲裁公會將有絕對酌情權，而人工智能系統將為仲裁程序選擇最合適的仲裁員。'
		,'Print':'打印',
		'Amend':'修改',
		'Re-enter':'重新輸入',
		'I certify that information contained in the Response is true and correct and consent to submit the difference to arbitration.':'本人核證本回應書所載詳情均屬真實及準確及同意以仲裁方法處理分歧。',
		'I certify that information contained in the Arbitration Notice is true and correct.':'本人核證本仲裁通知書所載詳情均屬真實及準確。',
		'Hearing not scheduled or meeting time not yet arrive':'電話會議未安排或會議時間尚未到',
		'Schedule Meeting with Video':'安排視頻會議',
		'Schedule Meeting Audio Only':'安排音頻會議',
		'Deliver Award':'作出裁決',
		'Identity Number':'證件號碼',
		'The arbitration fees will be paid to the arbitration service provider approved by Hong Kong Arbitration Society.':'仲裁費將向香港仲裁公會認可的仲裁服務提供機構繳交。',
		'Release':'發布',
		'Dear Arbitrator, Please sign the award. If satisfied with signature, please click done. Once signed it will be released. you may resubmit the signature multiple times here. After release, you may download DOCX version and re-upload.':'親愛的仲裁員，請在裁決簽署。如果簽名已確認，請點擊完成。當簽名送出後，你可在這裡多次重新提交簽名。送出後，你可下載DOCX版本並重新上傳',
		'Done':'完成',
		'Reject':'拒絕',
		'Accept':'接受',
		'Does the arbitrator accept or reject this case?':'是否確認就閣下獲委任為處理爭議的仲裁員一事上並沒有任何利益衝突及同意獲委任為仲裁員？',
		'Does the admin accept or reject this case or require more information?':'行政部門是否接納或拒絕此案件或需要更多資料？',
		'The arbitrator has rejected the case.':'仲裁員拒絕了案件。',
		'The Arbitrator has not delivered the Award yet.':'仲裁員尚未作出裁決',
	  'Send':'傳送',
	  'Prev. Page':'上一頁',
	  'Next Page':'下一頁',
	  'Download PDF':'下載PDF版 ',
	  'Download':'下載',
	  'PDF':'PDF',
	  'Upload':'上載',
	  'Word': 'Word',
	  'About Online Arbitration': '關於網上仲裁',
	  'description1':'香港仲裁公會推出香港首個全網上仲裁平台。香港仲裁公會的網上仲裁平台採用網上技術與高效仲裁方式相互結合，解決商業、借貸、貿易、貨品銷售、地產代理等糾紛。整個過程將在網上進行，令雙方毋須親身會面下解決爭議，亦可在不受地理距離影響下在任何時間進行，並且可進行非同步通訊。',
	  'description2':'仲裁程序與法院程序在很多方面相類似，但與調解不同，仲裁庭可作出“裁決”，並根據香港條例第609章「仲裁條例」，以與法院判決相同的方式強制執行。 仲裁員的裁決在香港、中國和全球超過160個國家均具有約束力及可以執行，對解決一帶一路倡議大多數國家及粵港澳大灣區的跨境爭議特別有利。',
	  'description3':'提出申索、委任仲裁員及發出裁決，全部均通過網上仲裁平台進行。初步審查、陳詞、查問和質詢亦可透過網上仲裁平台的聊天室進行。 文件、相片、影片和其他證據將可透過平台的雲端技術提交。 人工智能有助仲裁員和當事人精簡程序，協助當事人草擬狀書，歸納事實和證據以草擬仲裁裁決，並制定仲裁程序的爭議點。',
	  'description4':'仲裁過程有固定的時間表，並在過程開始後的1個月內發出具有約束力的裁決。 仲裁費用根據爭議金額釐定，與訴訟相比更確定、更相宜及更具成本效益。 獲勝一方更可在裁決發出後全數退回仲裁費用。 因此，爭議可以更高效和更具成本效益的方式下解決。',
	  'description5':'若果當事人有意使用網上仲裁平台，他們可以在合約上加上仲裁條款，表明他們希望通過網上仲裁平台解決爭議，或者他們可以在平台上網上簽署，以示同意使用網上仲裁平台。',
	  'description6':'如需展開網上仲裁，首先，如果雙方當事人已經同意仲裁，提出申索一方可以通過按平台首頁的“紅色按鈕”啟動程序，然後平台將開始聊天機械人對話，當事人並可透過聊天機械人提交資料及說明申索性質。',
	  'description7':'平台將使用人工智能技術草擬仲裁通知書，申請人可以通過驗證和付款、校對仲裁通知書，並可以進行電子簽署。 仲裁通知書將會在網上發送給答辯人。',
	  'description8':'當答辯人收到仲裁通知書，便可登入平台，使用相類似的程序為其案件作出辯護。',
	  'description9':'雙方當事人可以將相關文件上傳到平台的雲端，平台在收到當事人的建議後會委任仲裁員並透過平台網上通知雙方當事人。',
	  'description10':'平台上有一個聊天室提供給雙方當事人，他們可以在沒有仲裁員的情況下互相討論達成和解，及有另一個聊天室提供給雙方當事人和仲裁員，以便雙方當事人和仲裁員可在早期階段要求資料和文件，並在稍後階段雙方當事人和仲裁員可在同一個聊天室作出陳詞及進行查問。',
	  'description11':'仲裁員隨後將在網上發出裁決，即案件的結果，而整個過程將在一個月內完成。',
	  'description12':' ',
      'Arbitrator’s List': '仲裁員名單',
      'Arbitration Rules': '仲裁規則',
      'Arbitration Procedure': '仲裁程序',
      'Arbitration Agreement': '簽署仲裁協議',
      'Online Arbitration Clauses': '網上仲裁條款',
      'Arbitration Fee Calculator': '仲裁費用計算機',
      'Username': '用戶名稱',
	  '2FA Code': '2FA 代碼',
      'Password': '密碼',
      'Login': '登入',
      'Chatbot': '聊天機械人',
      'Userinfo': '用戶資料',
      'Verification': '驗證',
      'Choose Arbitrator': '選擇仲裁員',
	  'Choose Arbitrator2': ' ',
      'Read PDF': '請閱讀文件',
      'Signature': '簽署',
      'Payment': '付款',
      'Upload Documents': '上載文件',
	  'Upload Documents2': ' ',
      'Skip': '略過',
      'Next': '下一頁',
      'Phone Number Verification': '電話號碼驗證',
	  'Email Verification': '以電郵獲取驗證碼',
      "Please press 'RECEIVE CODE' to get a verification code": '請按”接收驗證碼”以獲取驗證碼',
	  "Thank you. Signature is saved.":"多謝你，簽名已經儲存咗。",
      'Receive Code': '接收驗證碼',
      'A text message with your code has been send to:': '驗證碼的信息已寄出到',
      'Verify': '驗證',
      'Please provide your signature below': '請於下方簽署，以確認仲裁通知書',
      'Please provide your signature belowAward': '請於下方簽署，以確認最終裁決',
      'Please provide your signature below.': '請於下方簽署，以確認回應書',
      'Clear': '清除',
      'Submit': '遞交',
	  'Confirm': '確認',
      'Confirm Signature': '確認簽署',
      'Please select payment method': '請選擇付款方式',
      'Order details': '訂單詳情',
      'Dispute amount' : '爭議金額',
      'Arbitration Fee': '仲裁費用',
	  'Final Total': '全部費用',
	  'Back':'返回',
	  'Final Total for Hearing': '電話會議最終總數',
	  'Choose Date/Time':'選擇日期/時間:  ',
      'Reset': '重設',
      'Upload': '上載',
      'Finish': '完成',
      'Add File': '增加載入檔案',
      'Case Information': '案件資料',
      'Arbitration Notice': '仲裁通知書',
      'Response': '回應書',
      'Documents': '文件',
      'Settlement': '和解',
      'Reopen Case': '重啟案件',
      'confirmSettleCase': '確定要和解/關閉此案件嗎？將不會再發送任何電郵、短信或處理此案件。',
      'confirmReopenCase': '確定要重啟此案件嗎？',
      'caseIsSettled': '此案件已和解/關閉。',
	  'Enquiries & Submission': '審查及陳詞',
	  'Hearing': '電話會議',
      'Award': '最終裁決',
	  'Case Number': '案件編號',
	  'Arbitrator': '仲裁員',
	  'rejected the case.': ' rejected the case. Please choose another arbitrator.',
	  'accepted the case.': ' accepted the case.',
	  'Waiting for arbitrator to accept or reject the case.': '正等待仲裁員接受或拒絕委任。',
	  'Claimant\'s Information': '申請人資料',
	  'Name': '姓名',
	  'E-mail': '電郵地址',
	  'Telephone No': '電話號碼',
	'Payment Status': '付款狀態',
	'Status': '狀態',
	'Claimant': '申請人',
	'Respondent': '答辯人',
	'Deadline to next step': '下一步的截止日期',
	'Claimant\'s Documents': '申請人文件',
	'Add No. of Days': '添加天數',
	'Timer Panel': '計時器面板',
	'Document Name': '文件名稱',
	'Uploaded Date': '上傳日期',
	'Document Number': '文件名稱',
	'File': '檔案',
	'Respondent\'s Documents': '答辯人文件',
	'HKAS\'s Documents': '香港仲裁公會文件',
	'Upload New Files': '上載新檔案',
	'reset': '重設',
	'browse': '瀏覽',
	'Browse': '瀏覽',
	'The Parties can negotiate for settlement in this page ': '當事人可在此頁面商討和解方案而仲裁員無法閱讀內容',
	'and the Arbitrator cannot read the contents': '當事人可在此頁面商討和解方案而仲裁員無法閱讀內容',
	'Claimant Offer': '申索人的建議',
	'Respondent Offer': '答辯人的建議',
	'Make a new offer': '作出新的建議',
	'Accept': '接受',
	'Refuse': '拒絕',
	'Offer': '建議',
	'The Parties and the Arbitrator can make Preliminary Enquiries': '香港仲裁公會、仲裁員和當事人可在此聊天室作出申請，發出命令及指示，及進行初步審查、質詢、陳詞及查問。',
	'Submission, Interrogatories and Enquiries in this chatroom': '',
	'Case File': '案件檔案',
	'New Case': '新案件',
	'Processing Cases': '處理中案件',
	'Closed Cases': '完結案件',
	'Rejected Cases': ' 駁回案件',
	'All Cases': '所有案件',
	'Online Arbitration': '網上仲裁',
	'Setting': '設定',
	'Personal Information': '個人資料',
	'Change Password': '變更密碼',
	'Logout': '登出',
	'Forgot Password': '忘記密碼',
	'Please enter the username of your account. An email will be sent to your email address for recovery.':'請輸入你的用戶名字。我們會傳送電郵到你的電郵地址以復原帳戶。',
	'About Online Arbitration': '關於網上仲裁',
	'Arbitrator’s List': '仲裁員名單',
	'Arbitration Rules': '仲裁規則',
	'arbitration_agreement1': '以下簽字各方，同意',
	'arbitration_agreement2': '簡單地描述已出現或可能引起的爭議、糾紛、分歧或索賠的合同',
	'arbitration_agreement3': '引起的或與之相關的任何爭議、糾紛、分歧或索賠（包括任何有關非合同性義務的爭議）提交由香港仲裁公會按照香港仲裁公會網上仲裁規則進行機構仲裁。',
	'For an amount in dispute (HK$)': '爭議金額(港幣$)',
	'Online Arbitration Fees': '網上仲裁費用',
	'Arbitration Fees (HK$)': '仲裁費用(港幣$)',
	'Enter dispute amount': '輸入爭議金額',
	'Arbitrator fee': '仲裁員費用',
	'Any dispute or difference arising out of or in connection with this contract shall be referred to and finally determined by arbitration administrated by the Hong Kong Arbitration Society and in accordance with the HKAS Online Arbitration Rules for the time being in force. The arbitration proceedings shall be conducted in English and the Award shall be written in English': '凡因本合同所引起的或與之相關的任何爭議或意見分歧，均應提交香港仲裁公會進行機構仲裁，並按其現行有效的香港仲裁公會網上仲裁規則最終解決。仲裁程序應以中文進行，裁決應以中文草擬。',
	'Signed': '簽署',
	'1st Party': '第一當事人',
	'2nd Party': '第二當事人',
	'Date': '日期',
	'Respondent\'s Information': '答辯人資料',
	'Arbitration Clauses/Agreement': '電郵地址',
	'claimantArbitrator':'申請人的仲裁員:',
	'respondentArbitrator':'答辯人的仲裁員:',
	'The parties can fill in the details and sign this Agreement in order to refer the dispute to HKAS Online Arbitration Platform.':'',
	'Contact of 2nd Party':'第二方電話號碼 : ',
	'Contact of 1st Party':'第一方電話號碼 : ',
	'Name of 1st Party':'第一方的名稱 : ',
	'E-mail of 1st Party':'第一方的電子郵件 : ',
	'Name of 2nd Party':'第二方的名稱 : ',
	'E-mail of 2nd Party':'第二方的電子郵件 : ',
	'Signature of 1st Party:':'第一方簽名 : ',
	'Signature of 2nd Party:':'第二方簽名 : ',
	'1st Party email is required or incorrect':'第一方電子郵件是必需或不正確的',
	'2nd Party email is required or incorrect':'第二方電子郵件是必需的或不正確的',
	'1st Party name is required':'第一方名稱是必需的',
	'2nd Party name is required':'第二方名稱是必需的',
	'1st Party signature is required':'需要第一方簽名',
	'2nd Party signature is required':'需要第二方簽名',
	'The agreement has been successfully saved. Thank you.':'該協議已成功保存。 謝謝。',
	'Jurisdiction':'管轄權',
	'Enter Dispute Amount':'輸入爭議金額',
	'Occupation':'職業',
	'No offer yet':'還沒有建議。',
	'An error occurred, please try again / or offer was made by the other party.':'發生錯誤，請再試一次 / 或由另一方提出。',
	'Please input the description before uploading file.':'請在上傳文件前輸入説明',
	'The respondent has not yet responded.':'答辯人沒有存檔回應書。',
	'Yes':'是',
	'Send Again':'Send Again',
	'No':'沒有',
	'No2':'否',
	'Accept':'接受',
	'Reject':'拒絕',
	'The Claimant proposes':'申請人建議',
	'The Respondent proposes':'答辯人建議',
	'to be the Arbitrator, will the Respondent accept or reject this proposal?':'為仲裁員，答辯人會接受或拒絕該建議？',
	'to be the Arbitrator, will the Claimant accept or reject this proposal?':'為仲裁員，申請人會接受或拒絕該建議？',
	'AgreementNo':'協議編號',
	'The following clause can be added by the parties to a contract who wish to have any future disputes referred to efficient arbitration in HKAS’s Online Arbitration Platform:':'希望在香港仲裁公會的網上仲裁平台進行高效仲裁以解決未來爭議的當事人，可在合同中加入仲裁條款如下:',
	'(Parties to an existing dispute in which neither an arbitration clause nor a previous agreement with respect to arbitration exists, may sign the following agreement to refer such dispute to arbitration through our Online Arbitration Platform)':'(若爭議已發生,而當事人之間的協議並沒有仲裁條款,而當事人亦未事先訂立仲裁協議,當事人可簽署以下協議同意於本網上仲裁平台通過仲裁解決爭議）',
	'WeChat Pay / AliPay':'支付寶 / 微信支付',
	'PayPal / CreditCard':'PayPal / 信用卡',
	'fps':'快速支付系統',
	'Full Docx': 'Full Docx',
	'Please choose arbitrator.':'請選擇仲裁員。',
	'Please upload word (.docx) file and it will be converted to PDF automatically.':'請上傳word（.docx）文件，它將自動轉換為PDF。',
	'Please choose your arbitrator.':'請選擇您的仲裁員。',
	'uploading':'上傳...',
	'SubmitAndSetAsDefault':'設為預設',
	'useDefaultSignature':'使用預設',
	'Scheduled Award Delivery Date':'預定裁決發送日期',
	'Schedule':'設定時間',
	'Cancel Schedule':'取消時間設定',
	'The scheduled award delivery is on':'預定裁決將於以下日期發送',
    }
  }